import { FormikErrors, useFormikContext } from "formik";
import { Link, useLocation } from "react-router-dom";
import InputField from "../../../_shared/components/InputField/InputField";
import SelectField from "../../../_shared/components/SelectField/SelectField";
import { selectAreaCodes } from "../../../_shared/constants/areaCodes";
import { FormValues } from "../_shared/models/FormValues";
import brokerages from "../../../_shared/constants/brokerages";
import Button from "_shared/components/Button/Button";

interface Props {
  onNext: (values: FormValues, errors: FormikErrors<FormValues>) => void;
}

const Register: React.FC<Props> = ({ onNext: onSignup }) => {
  const { values, errors, validateForm } = useFormikContext<FormValues>();

  return (
    <div className="border-padding">
      <h2 className="welcome-text" style={{ fontWeight: 800, marginBottom: 5 }}>
        Sign up
      </h2>
      <h2 className="welcome-text" style={{ fontSize: 12 }}>
        Creating an account with Longbow is a simple 4-step process
      </h2>
      <form
        onSubmit={async (e) => {
          e.preventDefault();
          validateForm(values);
          onSignup(values, errors);
        }}
      >
        <div className="input-container">
          <div className="two-column">
            <InputField name="firstName" label="First Name" />
            <InputField name="lastName" label="Last Name" />
          </div>
          <InputField name="email" label="Email Address" />
          <div className="two-column">
            <SelectField
              name="areaCode"
              options={selectAreaCodes}
              label="Area Code"
              showValueSelected
            />
            <InputField name="phone" label="Mobile Number" />
          </div>
          <div className="two-column">
            <InputField name="password" type="password" label="Password" />
            <InputField
              name="confirmPassword"
              type="password"
              label="Confirm Password"
            />
          </div>
          <InputField name="twitter" label="Your Twitter @handle" optional />
          <SelectField
            name="brokerage"
            label="Primary Brokerage"
            options={brokerages}
          />
          <SelectField
            name="referral"
            label="How did you hear about us?"
            options={["Twitter", "Google Search", "Friend", "Other"]}
          />
        </div>
        <div style={{ marginTop: 32 }}>
          <Button data-testid="button-next" type="submit" fullWidth>
            Next
          </Button>
        </div>
      </form>

      <div className="already-have-account">
        <div className="justify-center">Already have an account?</div>
        <Link to="/login" className="login-link justify-center">
          LOG IN
        </Link>
      </div>
    </div>
  );
};

export default Register;
